<template>
  <div class="uniltwebgl">
    <iframe class="unilt"
            :src=url
            scrolling="no"
            frameborder="0">
    </iframe>
    <div class="back" v-if="jump"
         @click="back">
      <van-image width="30"
                 height="30"
                 :src=btnImg />
    </div>
  </div>
</template>

<script>
import { getUrlParams, wexinShare } from '@/utils/utils'
import { queryWxUserInfo, queryShart } from '@/api/user'
import { getArtistInfo } from '@/api/artist'
export default {
  name: 'uniltY',
  data: function () {
    return {
      btnImg: require('@/assets/btn-back.png'),
      galleryId: 0,
      userId: 0,
      wxUserInfo: '',
      code: '',
      url: '',
      artistInfo: [], // 艺术家信息
      jump: 0
    }
  },
  async created () {
    const param = getUrlParams()
    this.code = param.code || ''
    localStorage.setItem('code', param.code)
    // if (localStorage.getItem('code') === '' || localStorage.getItem('code') === 'undefined') {
    //   location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd195d7f108eab952&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo&state=123&forcePopup=true#wechat_redirect`)
    // }
    // window.open('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd195d7f108eab952&redirect_uri=http://room.yslt.art&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect')
    this.galleryId = param.galleryId
    this.userId = param.userId
    // this.wxUserInfo = this.$route.query.wxUserInfo
    const res = await queryWxUserInfo(param.code)
    this.wxUserInfo = res.result
    await this.getArtist()
    await this.weixin()
    const jump = localStorage.getItem('__jump')
    if (jump === 1) {
      this.jump = jump
      localStorage.removeItem('__jump')
    }
    this.url = `http://room.yslt.art/?onSharePage=1&galleryId=${this.galleryId}&wxUserInfo=${this.wxUserInfo}`
  },
  computed: {
    // unilt链接
    // url () {
    //   const url = `http://room.yslt.art/?onSharePage=1&galleryId=${this.galleryId}&wxUserInfo=${this.wxUserInfo}`
    //   console.log(url)
    //   return url
    // }
  },
  methods: {
    back () {
      this.$router.back()
    },
    // 获取艺术家个人信息
    async getArtist () {
      try {
        const res = await getArtistInfo(this.userId)
        this.artistInfo = res.result
      } catch (error) {
        console.log('获取艺术家个人信息失败', error)
      }
    },
    // 微信二次分享
    async weixin () {
      const res = await queryShart({ url: `${location.href.split('#')[0].toString()}` })
      this.$nextTick(() => {
        let title = '云上美术馆'
        let brief = '云上美术馆'
        let coverUrl = ''
        if (this.userId && this.userId > 0) {
          title = this.artistInfo.nickname + '云上美术馆'
          brief = this.artistInfo.brief
          coverUrl = this.artistInfo.avatar
        }
        wexinShare(res.result, {
          title: title,
          desc: brief,
          link: `http://room.yslt.art/SharePageTest/?userId=${this.userId}&galleryId=${this.galleryId}#/unilty`,
          imgUrl: coverUrl
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
//横屏
@media only screen and (orientation: landscape) {
  .uniltwebgl {
    position: relative;
    // transform: rotate(0deg);
    .unilt {
      // position: absolute;
      width: 100vw;
      height: 100vh;
      display: block;
    }
    .back {
      width: 30px;
      height: 30px;
      position: fixed;
      top: 25px;
      right: 25px;
      z-index: 99999999 !important;
    }
  }
}
//竖屏
@media only screen and (orientation: portrait) {
  .uniltwebgl {
    position: relative;
    transform: rotate(90deg);
    .unilt {
      width: 100vh;
      height: 100vw;
      display: block;
    }
    .back {
      width: 30px;
      height: 30px;
      position: fixed;
      top: 20px;
      left: 90vh;
      z-index: 9999999 !important;
    }
  }
}
</style>
